import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	components: {
		'app': {
			'cardProps': {
				'props': {},
				'queries': {
					'hide': {
						'code': 'risk_indicator',
						'collectionItemValueConditional': {
							'conditions': [
								{
									'field': 'risk_level',
									'operator': 'not-in',
									'value': [
										'1',
										'2',
										'3',
										'4',
										'5',
									],
								},
							],
						},
						'entityType': 'CLSS',
						'queryOptionsType': 'statistics',
					},
					'title': {
						'queryOptionsType': 'none',
						'value': 'Risk Rating',
					},
					'titleLevel': {
						'queryOptionsType': 'none',
						'value': 3,
					},
					'tooltips': [
						{
							'content': {
								'key': 'risk_rating',
								'queryOptionsType': 'disclaimers',
							},
							'fixedTooltip': {
								'queryOptionsType': 'none',
								'value': false,
							},
							'position': {
								'queryOptionsType': 'none',
								'value': 'right',
							},
							'target': 'title',
							'trigger': {
								'queryOptionsType': 'none',
								'value': 'click',
							},
						},
					],
				},
			},
			'factList': {
				'props': {
					'items': [],
				},
				'queries': {
					'items': [
						{
							'appAssetProps': {
								'src': {
									'key': 'riskscore_{sub:ratings_value}.svg',
									'queryOptionsType': 'asset',
									'subQueries': [
										{
											'code': 'risk_indicator',
											'entityType': 'CLSS',
											'index': 0,
											'key': 'risk_level',
											'queryId': 'ratings_value',
											'queryOptionsType': 'statistics',
										},
									],
								},
							},
							'dataType': {
								'queryOptionsType': 'none',
								'value': 'app-asset',
							},
							'value': {
								'queryOptionsType': 'asset',
							},
						},
					],
				},
			},
		},
	},
};
